/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Flat_Quiet_Goat_PurrInputs */

const en_flat_quiet_goat_purr = /** @type {(inputs: Flat_Quiet_Goat_PurrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more labels`)
};

const de_flat_quiet_goat_purr = /** @type {(inputs: Flat_Quiet_Goat_PurrInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} weitere Labels`)
};

/**
* | output |
* | --- |
* | "+{count} more labels" |
*
* @param {Flat_Quiet_Goat_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_quiet_goat_purr = /** @type {((inputs: Flat_Quiet_Goat_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Quiet_Goat_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_quiet_goat_purr(inputs)
	return de_flat_quiet_goat_purr(inputs)
});